/* eslint-disable react-hooks/rules-of-hooks */
import { useState } from "react";

import axios, { AxiosRequestConfig } from "axios";

export const useReportStatusQuery = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [status, setStatus] = useState<String>("");
  const getReportStatus = async (id: number) => {
    try {
      setLoading(true);
      const config: AxiosRequestConfig = {
        method: "get",
        url: process.env.REACT_APP_API_URL + "/report/" + id + "/status",
      };
      const response = await axios.request(config);
      const reportStatus = response.data;
      setStatus(reportStatus);
      return reportStatus;
    } catch (e) {
      // Handle fetch error
      setError("something went wrong");
    } finally {
      setLoading(false);
    }
  };
  return { getReportStatus, loading, status, error };
};
